import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next'; // Dodato
import { ImageUrl } from 'src/constants/imagesConst';

/* MODAL ZA ZABORAVLJENU LOZINKU */
const ForgotPasswordModal = ({ isOpen, onClose, onSubmit }) => {
  const { t } = useTranslation();
  const [email, setEmail] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();
    if (email) {
      onSubmit(email);
    }
  };

  useEffect(() => {
    if (isOpen) {
      setEmail('');
    }
  }, [isOpen]);

  return (
    <div
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        backgroundColor: 'rgba(0, 0, 0, 0.5)',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        zIndex: 9999
      }}
    >
      <div
        style={{
          backgroundColor: 'white',
          padding: '25px 20px', // Manji padding za elegantniji izgled
          borderRadius: '10px',
          textAlign: 'center',
          width: '350px',
          boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)',
          position: 'relative'
        }}
      >
        {/* Dodajemo sliku kengura */}
        <img
          src="/kengur2/assets/kengur.png"
          alt="Kengur"
          style={{ width: '40px', marginBottom: '15px' }}
        />
        <h3
          style={{
            fontSize: '14px',
            fontWeight: '400',
            marginBottom: '20px',
            color: '#333'
          }}
        >
          {t('dialog.enterEmail')} {/* Prevod za tekst */}
        </h3>
        <form onSubmit={handleSubmit}>
          <input
            type="email"
            placeholder={t('dialog.email')}
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
            style={{
              width: '100%',
              padding: '12px', // Malo veći padding za moderan izgled
              marginBottom: '20px',
              borderRadius: '6px',
              border: '1px solid #ddd',
              fontSize: '14px', // Profesionalna veličina slova
              boxShadow: 'inset 0 1px 2px rgba(0, 0, 0, 0.1)', // Unutrašnji senka za dubinu
              transition: 'border-color 0.3s',
              outline: 'none',
              color: '#333'
            }}
          />
          <div
            style={{ display: 'flex', gap: '10px', justifyContent: 'center' }}
          >
            <button
              type="submit"
              style={{
                backgroundColor: '#007bff',
                color: 'white',
                border: 'none',
                borderRadius: '5px',
                cursor: 'pointer',
                fontSize: '13px',
                width: '100px',
                height: '40px', // Dodavanje visine za bolji izgled dugmeta
                display: 'flex', // Fleksibilno poravnanje
                justifyContent: 'center', // Horizontalno centriranje
                alignItems: 'center' // Vertikalno centriranje
              }}
            >
              {t('dialog.send')} {/* Prevod za "Pošalji" */}
            </button>
            <button
              type="button"
              onClick={onClose}
              style={{
                backgroundColor: '#6c757d',
                color: 'white',
                border: 'none',
                borderRadius: '5px',
                cursor: 'pointer',
                fontSize: '13px',
                width: '100px',
                height: '40px', // Dodavanje visine za bolji izgled dugmeta
                display: 'flex', // Fleksibilno poravnanje
                justifyContent: 'center', // Horizontalno centriranje
                alignItems: 'center' // Vertikalno centriranje
              }}
            >
              {t('dialog.close')} {/* Prevod za "Zatvori" */}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default ForgotPasswordModal;
